import { Utils } from 'mw-style-react';

export const GET_ACTORS = Utils.createRequestTypes('GET_ACTORS');
export const GET_ACTOR_BY_IDS = Utils.createRequestTypes('GET_ACTOR_BY_IDS');
export const GET_ACTOR = Utils.createRequestTypes('GET_ACTOR');
export const GET_LINKED_ACTORS = Utils.createRequestTypes('GET_LINKED_ACTORS');
export const CREATE_ACTOR = Utils.createRequestTypes('CREATE_ACTOR');
export const UPDATE_ACTOR = Utils.createRequestTypes('UPDATE_ACTOR');
export const GET_EDGE = Utils.createRequestTypes('GET_EDGE');
export const CREATE_EDGE = Utils.createRequestTypes('CREATE_EDGE');
export const CREATE_MASS_EDGES = Utils.createRequestTypes('CREATE_MASS_EDGES');
export const GET_EDGE_TYPES = Utils.createRequestTypes('GET_EDGE_TYPES');
export const GET_EDGE_TYPE = Utils.createRequestTypes('GET_EDGE_TYPE');
export const STARRED_ACTOR = Utils.createRequestTypes('STARRED_ACTOR');
export const UPDATE_ACTOR_VIEW = Utils.createRequestTypes('UPDATE_ACTOR_VIEW');
export const GET_ACTOR_GLOBAL_LINKS = Utils.createRequestTypes(
  'GET_ACTOR_GLOBAL_LINKS'
);
export const SET_ACTIVE_ELEMENT =
  Utils.createRequestTypes('SET_ACTIVE_ELEMENT');
export const GET_DEFAULT_ACTOR_TPL = Utils.createRequestTypes(
  'GET_DEFAULT_ACTOR_TPL'
);
export const GET_ACTOR_TPL = Utils.createRequestTypes('GET_ACTOR_TPL');
export const UPDATE_EDGE = Utils.createRequestTypes('UPDATE_EDGE');
export const REMOVE_EDGE = Utils.createRequestTypes('REMOVE_EDGE');
export const REMOVE_NODES_EDGE = Utils.createRequestTypes('REMOVE_NODES_EDGE');
export const REMOVE_ACTOR = Utils.createRequestTypes('REMOVE_ACTOR');
export const SEARCH_ACTORS = Utils.createRequestTypes('SEARCH_ACTORS');
export const ADD_ACTOR = Utils.createRequestTypes('ADD_ACTOR');
export const BULK_ADD_TO_GRAPH = Utils.createRequestTypes('BULK_ADD_TO_GRAPH');
export const BULK_REMOVE_FROM_GRAPH = Utils.createRequestTypes(
  'BULK_REMOVE_FROM_GRAPH'
);
export const GET_ALL_ACTORS = Utils.createRequestTypes('GET_ALL_ACTORS');
export const GET_TEMPLATE_ACTORS = Utils.createRequestTypes(
  'GET_TEMPLATE_ACTORS'
);
export const CREATE_ACTOR_FILTER = Utils.createRequestTypes(
  'CREATE_ACTOR_FILTER'
);
export const UPDATE_ACTOR_FILTER = Utils.createRequestTypes(
  'UPDATE_ACTOR_FILTER'
);
export const REMOVE_ACTOR_FILTER = Utils.createRequestTypes(
  'REMOVE_ACTOR_FILTER'
);
export const GET_ACTOR_FILTERS = Utils.createRequestTypes('GET_ACTOR_FILTERS');
export const GET_FILTER = Utils.createRequestTypes('GET_FILTER');
export const SEARCH_ACTOR_FILTERS = Utils.createRequestTypes(
  'SEARCH_ACTOR_FILTERS'
);

export const ADD_ACTOR_ATTACHES =
  Utils.createRequestTypes('ADD_ACTOR_ATTACHES');
export const REMOVE_ACTOR_ATTACHES = Utils.createRequestTypes(
  'REMOVE_ACTOR_ATTACHES'
);

export const CREATE_ACTOR_LIST = Utils.createRequestTypes('CREATE_ACTOR_LIST');
export const UPDATE_ACTOR_LIST = Utils.createRequestTypes('UPDATE_ACTOR_LIST');
export const REMOVE_ACTOR_LIST = Utils.createRequestTypes('REMOVE_ACTOR_LIST');
export const SEND_ACTORS_DATA = Utils.createRequestTypes('SEND_ACTORS_DATA');
export const ACTOR_ACCESS = Utils.createRequestTypes('ACTOR_ACCESS');
export const GET_ACTORS_BALANCE =
  Utils.createRequestTypes('GET_ACTORS_BALANCE');
export const SET_ACTOR_MULTIPLICATOR = Utils.createRequestTypes(
  'SET_ACTOR_MULTIPLICATOR'
);
export const COPY_FROM_GRAPH = Utils.createRequestTypes('COPY_FROM_GRAPH');
export const PASTE_TO_GRAPH = Utils.createRequestTypes('PASTE_TO_GRAPH');

export const SET_ACTIVE_ACTOR = 'SET_ACTIVE_ACTOR';
export const SET_ACTORS_REQ_STATUS = 'SET_ACTORS_REQ_STATUS';
export const CLEAR_LIST_ACTORS = 'CLEAR_LIST_ACTORS';
export const CLEAR_ACTOR_FILTERS = 'CLEAR_ACTOR_FILTERS';
export const CLEAR_ACTOR = 'CLEAR_ACTOR';

export const MIN_PANEL_WIDTH = 400;
export const MAX_PANEL_WIDTH = 640;
export const DAGREE_NODE_SEP = 168;
export const AUTO_LAYER_PAGE_LIMIT = 25;

// SYSTEM ACTORS
export const SAVE_SYSTEM_ACTOR = Utils.createRequestTypes('SAVE_SYSTEM_ACTOR');
export const NON_FILTER_KEYS = [
  'withForm',
  'lastReaction',
  'reactionsCount',
  'reactionsStats',
];

// WS
export const WS_CREATE_ACTOR = 'WS_CREATE_ACTOR';
export const WS_UPDATE_ACTOR = 'WS_UPDATE_ACTOR';
export const WS_DELETE_ACTOR = 'WS_DELETE_ACTOR';
export const WS_CREATE_ATTACHMENTS = 'WS_CREATE_ATTACHMENTS';
export const WS_DELETE_ATTACHMENTS = 'WS_DELETE_ATTACHMENTS';
